
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.29 1.57v4.477c0 .833.32 1.25.96 1.25.292 0 .612-.138.96-.414l.321.46c-.656.522-1.26.782-1.812.782-.604 0-1.052-.156-1.344-.469-.286-.312-.43-.817-.43-1.515V1.57h-.687c-.412 0-.73.067-.953.202-.224.13-.461.36-.711.688l-.5-.414C.573 1.396.982.979 1.32.797 1.66.609 2.11.516 2.672.516h4.61V1.57H4.288z","fill":"currentColor"}})])
          )
        }
      }
    